<router-outlet></router-outlet>

<ngx-spinner bdColor="rgba(10, 30, 48, 0.85)" size="medium" type="ball-clip-rotate" [fullScreen]="true">
  <div class="custom-spinner">
    <div class="spinner-ring"></div>
    <div class="spinner-ring spinner-ring-2"></div>
    <div class="spinner-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
    <p class="spinner-text">Loading...</p>
  </div>
</ngx-spinner>
